// =============================================================================
// ITALIAN RADICAL DESIGN - Main JavaScript
// =============================================================================
import Lenis from 'lenis';


// Import styles
import 'lenis/dist/lenis.css';
import '../scss/main.scss';

// Sections
// -----------------------------------------------------------------------------
import Banner from './sections/banner.js';
import Cart from './sections/cart.js';
import Header from './sections/header.js';
import HomeCollections from './sections/home-collections.js';
import NewsletterForms from './sections/newsletter-forms.js';
import CollectionGallery from './sections/collection-gallery.js';
import ProductCarousel from './sections/product-carousel.js';
import ProductDetails from './sections/product-details.js';
import ProductGrid from './sections/product-grid.js';
import Product from './sections/product.js';
import Timeline from './sections/timeline.js';
import Facets from './snippets/facets.js';
import MiniCart from './snippets/minicart.js';
import QuoteDrawer from './snippets/quote-drawer.js';
import Wishlist from './snippets/wishlist.js';
import WishlistPage from './sections/wishlist-page.js';


// Global initialization
// -----------------------------------------------------------------------------

let resizeTimeout = null;
let wWidth = window.innerWidth;

const disableTransitions = () => {
  if (wWidth == window.innerWidth) return;
  clearTimeout(resizeTimeout);
  document.body.classList.add('-resizing');
  wWidth = window.innerWidth;
  resizeTimeout = setTimeout(() => {
    document.body.classList.remove('-resizing');
  }, 300);
};

document.addEventListener('DOMContentLoaded', () => {
  const lenis = new Lenis();

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);

  window.lenis = lenis;


  const _header = new Header();
  const _banner = new Banner();
  const _homeCollections = new HomeCollections();
  const _newsletterForms = new NewsletterForms();
  const _collectionGallery = new CollectionGallery();
  const _productCarousel = new ProductCarousel();
  const _productGrid = new ProductGrid();
  const _facets = new Facets();
  const _product = new Product();
  const _timeline = new Timeline();
  const _productDetails = new ProductDetails();
  const _cart = new Cart();
  const _miniCart = new MiniCart();
  const _quoteDrawer = new QuoteDrawer();
  const _wishlist = new Wishlist();
  const _wishlistPage = new WishlistPage();

  window.addEventListener('resize', () => {
    disableTransitions();
  });
});
